export default __webpack_public_path__ + "static/media/service_development_reactjs.2d754522.png";